var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCash64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2272_9058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29443 18.5943L3.29443 47.3H60.706V18.5943L3.29443 18.5943Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.23 18.5943L14.23 47.3H25.1655V18.5943H14.23Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2749 27.1323V25.3447",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2749 39.6451V37.8575",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6039 27.1322C45.9587 27.1322 45.7646 27.1322 44.6928 27.1322C43.0851 27.1322 41.7817 28.3327 41.7817 29.8135C41.7817 31.2944 43.0851 32.4948 44.6928 32.4948H45.8572C47.465 32.4948 48.7683 33.6953 48.7683 35.1761C48.7683 36.657 47.465 37.8574 45.8572 37.8574C44.7854 37.8574 44.5913 37.8574 42.9462 37.8574",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2272_9058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCash64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCash64.738cc92d9bfee64ce3d419eee76f78b4.svg";
export { ForwardRef as ReactComponent };